import { Client } from 'api/client/types';
import { authorizedAxios } from 'library/axios/apiProvider';

export async function getClientUser(): Promise<Client> {
  const { data } = await authorizedAxios().get('/api/v1/client/');
  return data;
}
